import React, { useEffect, Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable } from '../../../../components/custom/dataTable';
import $ from "jquery"
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import { gethistorylogOPA } from "../../../../actions/OPAAction";
import styles from "../../../../assets/jss/customStyle";
const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

class EditOPA_Historylog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            isError: false,
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId")
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        dispatch(gethistorylogOPA(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);

    }
    resize = () => {
        this.setState({})
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };
    render() {

        let { classes, menuToggle } = this.props;
        return (
            <>
                <div className="row">
                    <div className="mt-n3">
                        <div className="col-sm-12 col-12 px-0">
                            <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                <table id="dataTable" className="table">
                                    <thead>
                                        <tr className="">
                                            <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '170px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                            <th className="border-top border-right" style={{ width: '6%', minWidth: window.innerWidth < 1000 ? '80px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                            <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                            <th className="border-top border-right" style={{ width: '64%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontFamily: 'Segoe UI' }}>
                                        {this.props.historyLog && this.props.historyLog.map((i) => (
                                            <tr>
                                                <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                    {moment(i.TimeStamp).format(this.props.settings.Convention  ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                </td>
                                                <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
}

EditOPA_Historylog.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditOPA_Historylog))
);


